module.exports = __webpack_public_path__ + "img/bg_1@2x.95aaef3f.png";